// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"Button_nextButton__hppcb"};